import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';

import { mapLoader } from './components/footer/mapLoader.js';
import { navicon } from './components/footer/navicon.js';
import { navigation } from './components/footer/navigation.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { elementInView } from './components/footer/elementInView.js';
import { adjustMasthead } from './components/footer/adjustMasthead.js';
import { addDataTextToElements } from './components/footer/addDataTextToElements.js';
import { adjustMaxWidth } from './components/footer/adjustMaxWidth.js';
import { farloUiPostCarousel } from './components/footer/flickity-tickets.js'
import { farloUiCastCarousel } from './components/footer/flickity-cast.js'
import { farloUiReviews } from './components/footer/flickity-reviews.js'
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { farloUiCreativesCarousel } from './components/footer/flickity-creatives.js'
//import FarloTVEffect from './vendors/farlo-tv-effect';

import { farloUiMcSignup } from './components/footer/farloUiCrmSignup.js';


((document, window, history) => {
	const pushState = history.pushState;


	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};


	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('.wp-block-embed__wrapper').forEach(function (_sel) {
				const embedDiv = document.createElement('div');

				if (!(_sel.querySelector('.wp-block-embed__player'))) {
					embedDiv.className = 'wp-block-embed__player';
					_sel.append(embedDiv);

					embedDiv.addEventListener('click', (e) => {
						const iframe = e.currentTarget.parentNode.querySelector('iframe');
						const dataSrc = iframe.getAttribute('data-src') || iframe.getAttribute('src');

						e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

						// Remove the existing iframe
						iframe.remove();

						// Create a new iframe with autoplay parameters
						const newIframe = document.createElement('iframe');
						newIframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
						newIframe.setAttribute('allow', 'autoplay'); // Ensure autoplay is allowed
						newIframe.setAttribute('frameborder', '0');
						newIframe.setAttribute('allowfullscreen', '');

						// Append the new iframe to the wrapper
						e.currentTarget.parentNode.appendChild(newIframe);
					});
				}
			});
		}


		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.masthead')) {
			window.addEventListener('resize', adjustMasthead);
			window.addEventListener('load', adjustMasthead);


		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
				_el.dataset.toggled = "0";
				_el.addEventListener("click", () => {
					toggleFAQ(_el);
				})
			});
		}

		if (document.querySelector('.site-farlo-ui-animated')) {
			document.querySelectorAll('.site-farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});
		}


		if (document.querySelector('.site-main')) {
			addScrolledClass();
		}


		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar();
			});
		}


		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}


		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		if (document.querySelector('.ticketing-blocks')) {
			document.querySelectorAll('.ticketing-blocks').forEach((_sel) => {
				farloUiPostCarousel(_sel);
			});
		}

		if (document.querySelector('.site-cast')) {
			document.querySelectorAll('.site-cast').forEach((_sel) => {
				farloUiCastCarousel(_sel);
			});
		}

		if (document.querySelector('.site-reviews__listing')) {
			document.querySelectorAll('.site-reviews__listing').forEach((_sel) => {
				farloUiReviews(_sel);
			});
		}

		if (document.querySelector('.site-creative-team')) {
			document.querySelectorAll('.site-creative-team').forEach((_sel) => {
				farloUiCreativesCarousel(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}
	});

	window.addEventListener('load', () => {
		setTimeout(() => {
			document.querySelector('body').classList.add('loaded');
		}, 0);
	});




	// Run the function when the document is ready
	document.addEventListener('DOMContentLoaded', adjustMaxWidth);





	// Call the function when the page finishes loading
	window.addEventListener('load', addDataTextToElements);


	const crm_data = _farlo.storage.get("_farlo_crm");
	if (crm_data) {
		_farlo.events.generic(crm_data);
	}

	function getSource() {
		const urlParams = new URLSearchParams(window.location.search);
		const referrer = document.referrer;
		let source = "Direct"; // default to direct
		if (referrer) {
			const referrerURL = new URL(referrer);
			if (referrerURL.hostname.match(/(google)|(bing)|(yahoo)/gi)) {
				source = "Organic Search";
			} else if (referrerURL.hostname.match(/(facebook)|(instagram)|(twitter)/gi)) {
				source = "Organic Social";
			} else {
				source = "Referral - " + referrerURL.hostname;
			}
		}
		// Check for UTM parameters
		if (urlParams.has('utm_medium')) {
			const utmMedium = urlParams.get('utm_medium').toLowerCase();
			switch (utmMedium) {
				case 'cpc':
				case 'ppc':
					source = "Paid Search";
					break;
				case 'social':
					source = "Social Media";
					break;
				case 'email':
					source = "Email";
					break;
				default:
					source = "Other Campaign - " + utmMedium;
					break;
			}
		}

		return source;
	}
	if (_farlo.storage.get("source", "session")) {
		_farlo.storage.set("source", getSource(), "session");
	}



})(document, window, history);
